import '@ionic/core';
import { DateTime } from 'luxon';
import { Component, Element, Event, EventEmitter, h, Prop, State, Watch } from '@stencil/core';

import axios from 'axios';

@Component({
  tag: 'interest-form-view',
  styleUrl: 'interest-form-view.css',
  shadow: true
})
export class OpportunityCard {
    @Element() el: HTMLElement;

    @Event() volunteerInformationUpdated: EventEmitter;

    @Prop({ attribute: 'volunteer-name' }) defaultVolunteerName: string;
    @Prop({ attribute: 'volunteer-email' }) defaultVolunteerEmail: string;
    @Prop({ attribute: 'volunteer-phone-number' }) defaultVolunteerPhoneNumber: string;
    @Prop({ attribute: 'volunteer-bar-number' }) defaultVolunteerBarNumber: string;
    @Prop({ attribute: 'cohort-id' }) opportunityCohortId: number = -105;
    @Prop({ attribute: 'partner-id' }) opportunityPartnerId: number = -115;
    @Prop({ attribute: 'opportunity-id' }) opportunityId: number = -125;
    @Prop({ attribute: 'opportunity-type' }) opportunityType: string = 'case';
    @Prop({ attribute: 'clinic-sessions' }) clinicSessions: any[] | string = [];

    @State() isSubmitable: boolean = true
    @State() submitLabel: string = 'Submit';
    @State() sessionList: any[];
    @State() selectedCount: number = 0;
    @State() sessionSelectorText: string = 'Please select a session.';

    private baseURL: string;
    
    private volunteerComment: string;
    private volunteerName: string;
    private volunteerEmail: string;
    private volunteerPhoneNumber: string;
    private volunteerBarNumber: string;
    private preparedSessionList: any[];
    private selectedSessions: any[];

    private _clinicSessions: any[];

    @Watch('opportunityCohortId')
    opportunityCohortIdWatcher(newCohortValue: string) {
        this.baseURL = `https://api.probono.savvysuit.com/v2/cohort/${newCohortValue}/partners/${this.opportunityPartnerId}`
    }

    @Watch('opportunityPartnerId')
    opportunityPartnerIdWatcher(newPartnerValue: string) {
        this.baseURL = `https://api.probono.savvysuit.com/v2/cohort/${this.opportunityCohortId}/partners/${newPartnerValue}`
    }

    @Watch('clinicSessions')
    clinicSessionWatcher(newValue: any[] | string | string) {
        // console.log(`Updating clinic session list in interest form for ${this.opportunityId}`)
        this._clinicSessions = (typeof newValue === 'string') ? JSON.parse(newValue) : newValue;
        this.prepareSessionList(this._clinicSessions);
    }

    componentWillLoad() {
        this.volunteerName = this.defaultVolunteerName;
        this.volunteerEmail = this.defaultVolunteerEmail;
        this.volunteerPhoneNumber = this.defaultVolunteerPhoneNumber;
        this.volunteerBarNumber = this.defaultVolunteerBarNumber;
        this.volunteerComment = '';
        this.selectedSessions = [];
        this.preparedSessionList = [];

        this.clinicSessionWatcher(this.clinicSessions);

        const styleBodyText = ".SSPBSessionSelectorAlert { --max-width: unset !important; --width: 500px !important; }";
        const alertStyleText = document.createTextNode(styleBodyText);
        const alertStyle: any = document.createElement('style');

        alertStyle.type = 'text/css';
        alertStyle.appendChild(alertStyleText)

        document.getElementsByTagName("head")[0].appendChild(alertStyle);
    }

    componentWillRender() {
        this.clinicSessionWatcher(this.clinicSessions)

        this.baseURL = `https://api.probono.savvysuit.com/v2/cohort/${this.opportunityCohortId}/partners/${this.opportunityPartnerId}`
    }

    @Watch('defaultVolunteerName')
    updateVolunteerName(newName: string) {
        this.volunteerName = newName;
    }

    @Watch('defaultVolunteerEmail')
    updateVolunteerEmail(newEmail: string) {
        this.volunteerEmail = newEmail;
    }

    @Watch('defaultVolunteerPhoneNumber')
    updateVolunteerPhoneNumber(newNumber: string) {
        this.volunteerPhoneNumber = newNumber;
    }

    @Watch('defaultVolunteerBarNumber')
    updateVolunteerBarNumber(newBarNumber: string) {
        this.volunteerBarNumber = newBarNumber;
    }

    processForm(event) {
        event.preventDefault();

        const that = this;

        let dataURL

        console.log(this);

        const dataPayload = {}
        dataPayload["vol_name"] = this.volunteerName.substring(0, 100);
        dataPayload["vol_email"] = this.volunteerEmail.substring(0, 100);
        dataPayload["vol_phone_no"] = this.volunteerPhoneNumber.substring(0, 25);

        // Optional inputs.
        dataPayload["vol_bar_no"] = ((this.volunteerBarNumber === undefined) || (this.volunteerBarNumber === null)) ? '' : this.volunteerBarNumber.substring(0, 10);
        dataPayload["vol_comment"] = ((this.volunteerComment === undefined) || (this.volunteerComment === null)) ? '' : this.volunteerComment.substring(0, 280);

        console.log(dataPayload);

        let submitReady = false

        // Determine the appropriate URL based on opportunity type.
        switch(this.opportunityType) {
            case 'clinic':
                dataURL = (this.baseURL + `/clinics/${this.opportunityId}/interestform`);
                dataPayload["vol_sessions"] = this.selectedSessions;

                try {
                    if (this.selectedSessions.length < 1) {
                        console.error('The user hasn\'t selected any sessions.');

                        alert('Please select at least 1 session.');
                    } else {
                        submitReady = true;
                    }
                } catch (SessionLengthError) {
                    console.error('We couldn\'t figure out how many sessions the user selected.');

                    alert('Please select at least 1 session.');
                }

                break;

            default:
                submitReady = true

                dataURL = (this.baseURL + `/cases/${this.opportunityId}/interestform`)                
        }

        // SEND DATA THROUGH AXIOS
        if (submitReady) {
            axios.post(dataURL, dataPayload)
            .then(function () {
                // console.log(response);
                console.log('Successfully submitted interest form.');

                // Disable the submit button.
                that.isSubmitable = false;
                that.submitLabel = 'Thank you';
            })
            .catch(function (error) {
                console.error('FAILURE: submitting interest form.', error.toString());

                alert('Failed to submit interest form, please try again in a few minutes.');
            });

            // Send the most recent volunteer information to the catalog.
            that.volunteerInformationUpdated.emit({
                volunteerName: this.volunteerName,
                volunteerEmail: this.volunteerEmail,
                volunteerPhoneNumber: this.volunteerPhoneNumber,
                volunteerBarNumber: this.volunteerBarNumber
            });
        }
    }

    handleNameValue(event) {
        this.volunteerName = event.target.value;
    }

    handleEmailValue(event) {
        this.volunteerEmail = event.target.value;
    }

    handlePhoneNumberValue(event) {
        this.volunteerPhoneNumber = event.target.value;
    }

    handleBarNoValue(event) {
        this.volunteerBarNumber = event.target.value;
    }

    handleCommentValue(event) {
        this.volunteerComment = event.target.value;
    }

    private prepareSessionList(clinicSessionsList) {
        this.preparedSessionList = []

        clinicSessionsList.forEach((session: any) => {
            const newSessionObj = Object.assign({}, session);

            const start_dateonly = DateTime.fromISO(session['start_date_time'], { zone: 'utc' }).toFormat('(EEE) LLL dd');
            const stop_dateonly = DateTime.fromISO(session['end_date_time'], { zone: 'utc' }).toFormat('(EEE) LLL dd');

            if(start_dateonly === stop_dateonly) {
                const start = DateTime.fromISO(session['start_date_time'], { zone: 'utc' }).toFormat('(EEE) LLL dd t');
                const stop = DateTime.fromISO(session['end_date_time'], { zone: 'utc' }).toFormat('t');

                newSessionObj['description'] = `${start} to ${stop}`
            } else {
                const start = DateTime.fromISO(session['start_date_time'], { zone: 'utc' }).toFormat('(EEE) LLL dd@t');
                const stop = DateTime.fromISO(session['end_date_time'], { zone: 'utc' }).toFormat('(EEE) LLL dd@t');

                newSessionObj['description'] = `${start} to ${stop}`
            }

            this.preparedSessionList.push(newSessionObj);
        })
    }

    private updateSessionsSelected = (e: any) => {
        try {
            this.selectedCount = e.detail.value.length;
        } catch (error) {
            this.selectedCount = 0;
        }

        if (this.selectedCount === 1) {
            this.sessionSelectorText = `${this.selectedCount} session selected`
        } else if (this.selectedCount > 1) {
            this.sessionSelectorText = `${this.selectedCount} sessions selected`
        } else {
            this.sessionSelectorText = `Please select a session.`
        }

        this.selectedSessions = e.detail.value;
    }

    render() {
        switch(this.opportunityType) {
            case 'case':
                return (
                    <div id="InterestFormStage">
                        <form onSubmit={((e) => this.processForm(e)).bind(this)}>
                            <ion-item>
                                <ion-input label="Name *" labelPlacement="floating" required type="text" value={this.volunteerName} name="vol_name" onIonChange={((event) => { this.handleNameValue(event) }).bind(this)}></ion-input>
                            </ion-item>
                            <ion-item>
                                <ion-input label="Email Address *" labelPlacement="floating" required type="email" inputmode="email" value={this.volunteerEmail} name="vol_email" onIonChange={((event) => { this.handleEmailValue(event) }).bind(this)}></ion-input>
                            </ion-item>
                            <ion-item>
                                <ion-input label="Phone Number *" labelPlacement="floating" required type="tel" inputmode="tel" value={this.volunteerPhoneNumber} name="vol_phone_no" onIonChange={((event) => this.handlePhoneNumberValue(event)).bind(this)}></ion-input>
                            </ion-item>
                            <ion-item>
                                <ion-input label="Bar No." labelPlacement="floating" type="text" value={this.volunteerBarNumber} name="vol_bar_no" onIonChange={((event) => this.handleBarNoValue(event)).bind(this)}></ion-input>
                            </ion-item>
                            <ion-item>
                                <ion-input label="Comment" labelPlacement="floating" type="text" value={this.volunteerComment} name="vol_comment" maxlength={256} onIonChange={((event) => this.handleCommentValue(event)).bind(this)}></ion-input>
                            </ion-item>
                            <ion-button disabled={!this.isSubmitable} type="submit">{this.submitLabel}</ion-button>
                        </form>
                    </div>
                );

            case 'clinic':
                return(
                    <div id="InterestFormStage">
                        <div id="InterestFormStage">
                            <form onSubmit={((e) => this.processForm(e)).bind(this)}>
                                <ion-select interfaceOptions={{cssClass: 'SSPBSessionSelectorAlert'}} id="SSPBSessionSelector" value={this.selectedSessions} multiple={true} onIonChange={this.updateSessionsSelected} selectedText={this.sessionSelectorText}>
                                    {this.preparedSessionList.map(session => {
                                        return (
                                            <ion-select-option value={session.clinic_session_id}>{session.description}</ion-select-option>
                                        );
                                    })}
                                </ion-select>
                                <ion-item>
                                    <ion-input label="Name *" labelPlacement="floating" required type="text" value={this.volunteerName} name="vol_name" onIonChange={((event) => this.handleNameValue(event)).bind(this)}></ion-input>
                                </ion-item>
                                <ion-item>
                                    <ion-input label="Email Address *" labelPlacement="floating" required type="email" inputmode="email" value={this.volunteerEmail} name="vol_email" onIonChange={((event) => { this.handleEmailValue(event) }).bind(this)}></ion-input>
                                </ion-item>
                                <ion-item>
                                    <ion-input label="Phone Number *" labelPlacement="floating" required type="tel" inputmode="tel" value={this.volunteerPhoneNumber} name="vol_phone_no" onIonChange={((event) => this.handlePhoneNumberValue(event)).bind(this)}></ion-input>
                                </ion-item>
                                <ion-item>
                                    <ion-input label="Bar No." labelPlacement="floating" type="text" value={this.volunteerBarNumber} name="vol_bar_no" onIonChange={((event) => this.handleBarNoValue(event)).bind(this)}></ion-input>
                                </ion-item>
                                <ion-item>
                                    <ion-input label="Comment" labelPlacement="floating" type="text" value={this.volunteerComment} name="vol_comment" maxlength={256} onIonChange={((event) => this.handleCommentValue(event)).bind(this)}></ion-input>
                                </ion-item>
                                <ion-button disabled={!this.isSubmitable} type="submit">{this.submitLabel}</ion-button>
                            </form>
                        </div>
                    </div>
                );

            default:
                return(
                    <div id="InterestFormStage">Unrecognized Opportunity Type</div>
                );
        }
    }
}
